import { ChartContainer } from './charts/ChartContainer';
import { BarChartComponent } from './charts/BarChartComponent';
import type { ChartDataPoint } from './charts/types';

interface IssuesChartProps {
  data: ChartDataPoint[];
}

export function IssuesChart({ data }: IssuesChartProps) {
  return (
    <ChartContainer title="Issues by Month">
      <BarChartComponent data={data} />
    </ChartContainer>
  );
}